<div class="estimate-detail ui-g-12 p-0">
  <!-- Start Estimate Status Details -->
  <div class="ui-g-12 padding-12">
    <ng-container *ngIf="!_estimate?.invoiceType">
      <!-- Authorization -->
      <div *ngIf="isDeferredServiceEnabled" class="ui-g-12 p-1 authorization mt-1">
        <p>AUTHORIZATIONS</p>

        <div class="ui-g-12 pt-2 pl-1 pr-1 pb-0">
          <div class="ui-g-6 pl-0 pt-0 pb-0 flex-between-center">
            <div class="flex-start-center">
              <span class="dot-pending"></span>
              <div class="mb-0 font-14 font-600 service-count">
                Pending
              </div>
            </div>

            <div class="p-0 text-right font-14 font-600 right-heading font-light">
              {{authServiceStatusCount.pending}}
            </div>
          </div>

          <div class="ui-g-6 pr-0 pt-0 pb-0 flex-between-center">
            <div class="flex-start-center">
              <span class="dot-authorization"></span>
              <div class="mb-0 font-14 font-600 service-count">
                Approved
              </div>
            </div>

            <div class="p-0 text-right font-14 font-600 right-heading font-light">
              {{authServiceStatusCount.approved}}
            </div>
          </div>
        </div>

        <div class="ui-g-12 pt-2 pl-1 pr-1 pb-0">
          <div class="ui-g-6 pl-0 pt-0 pb-0 flex-between-center">
            <div class="flex-start-center">
              <span class="dot-deffered"></span>
              <div class="mb-0 font-14 font-600 service-count">
                Deferred
              </div>
            </div>

            <div class="p-0 text-right font-14 font-600 right-heading font-light">
              {{authServiceStatusCount.deferred + authServiceStatusCount.deferredLocked}}
            </div>
          </div>

          <div class="ui-g-6 pr-0 pt-0 pb-0 flex-between-center">
            <div class="flex-start-center">
              <span class="dot-declined"></span>
              <div class="mb-0 font-14 font-600 service-count">
                Declined
              </div>
            </div>

            <div class="p-0 text-right font-14 font-600 right-heading font-light">
              {{authServiceStatusCount.declined}}
            </div>
          </div>
        </div>

        <div class="ui-g-12 pt-2 pl-1 pr-1 pb-0">
          <div class="ui-g-6 pl-0 pt-0 pb-0 flex-between-center" *ngIf="authServiceStatusCount.archived > 0">
            <div class="flex-start-center">
              <span class="dot-archived"></span>
              <div class="mb-0 font-14 font-600 service-count">
                Archived
              </div>
            </div>

            <div class="p-0 text-right font-14 font-600 right-heading font-light">
              {{authServiceStatusCount.archived}}
            </div>
          </div>

          <div class="ui-g-6 pr-0 pt-0 pb-0 flex-between-center">
          </div>
        </div>

        <button id="btn-estimate-view-authorization" [disabled]="isArchived && !isFinalizedRo"
          class="custom-button btn btn-primary btn-block btn-submit font-12 font-bold"
          [ngClass]="{'disabled-estimate-field': isArchived && !isFinalizedRo}"
          (click)="openServiceAuthorisationDialog()">
          <span [hidden]="authServiceStatusCount.pending === _estimate?.services?.length">
            View Authorization
          </span>

          <span [hidden]="authServiceStatusCount.pending !== _estimate?.services?.length">
            <i class="far fa-plus pr-2"></i>Authorize
          </span>
        </button>
      </div>

      <!-- Authorization -->
      <div *ngIf="!isDeferredServiceEnabled" class="ui-g-12 p-1 authorization mt-1">
        <p>AUTHORIZATIONS</p>

        <div class="mt-1">
          <div [ngClass]="{'disabled-estimate-field': isArchived}">
            <app-switch-button [id]="'estimate-auth-switch'" valueField="authorized"
              [value]="{ authorized: _estimate.authorized }" [options]="authorization"
              (appChange)="onStatusSelect('authorization', $event)"></app-switch-button>
          </div>
        </div>

        <span class="status-change-by" *ngIf="_estimate.authorized && _estimate.approvedAt">
          Authorization date: {{ authorizedBy.date }}, {{ authorizedBy.time }}
          <span class="capitalize"> ({{ authorizedBy.name }})</span>
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="!_estimate?.invoiceType else adjumentsInvoiceDetails">
      <!-- Marketing -->
      <div *ngIf="_isMarketingEnabled" class="ui-g-12 p-1 follow-up mt-2">
        <div class="d-flex justify-content-between align-items-center mb-2"
          [ngClass]="{'disabled-estimate-field': isArchived}">
          <p>UPCOMING FOLLOW-UPS ({{upcomingFollowUps?.length}})</p>
          <a class="font-bold text-primary font-13 pointer" (click)="handleViewAllFollowUp('view-upcoming')">
            View all
          </a>
        </div>

        <div class="accordian-empty-screen mt-1" *ngIf="!upcomingFollowUps?.length"
          [ngClass]="{'disabled-estimate-field': isArchived}">
          There are no Upcoming follow-ups
          <div class="text-center">
            <a class="font-bold text-primary font-14 mt-1 pointer" (click)="handleViewAllFollowUp('view-eligible')">
              <i class="far fa-plus"></i> Add follow-up
            </a>
          </div>
        </div>

        <!-- Campaign card -->
        <div class="width-100p follow-up-card mb-2" *ngFor="let campaign of upcomingFollowUps | slice: 0: 2">
          <!-- Campaign title -->
          <div class="flex-start-center">
            <i class="fal fa-alarm-clock pr-2"></i>

            <p class="m-0 font-600">{{campaign?.campaignTitle}}</p>
          </div>

          <!-- Campaign bottom -->
          <div class="flex-start-center">
            <i class="fal fa-calendar-alt font-gray-65 pr-2"></i>

            <p class="m-0 flex-between-center width-100p font-11">
              <span>Scheduled</span>

              <span>
                {{campaign?.scheduleAt | date: 'MMM d, yyyy hh:mma'}}
              </span>
            </p>
          </div>
        </div>
        <!-- Follow up card ends -->


        <!-- Attribution/Source campaign -->
        <div class="mt-2 flex-start-center text-uppercase">
          <p>Attributed/source campaign</p>
        </div>

        <div class="mt-1">
          <div [ngClass]="{'disabled-estimate-field': isArchived}" class="position-relative font-ellipses">
            <app-auto-complete theme="border" styleClassInputWrapper="p-2 pl-2 text-transform-uppercase"
              styleClassListWrapper="top-38 width-100p" listId="group-list-search-list" styleClassError="top-35 left-10"
              inactiveItemsKey="status" scrollHeight="330px" noRecordText="No items match your search" field="title"
              textAreaId="campaign-group-textarea" placeholder="SELECT SOURCE CAMPAIGN" [showDisabledIcon]="false"
              [maxAutoGrowHeight]="96" [selectInactiveItems]="false" [selectTextOnFocus]="true" [selectionOnTab]="true"
              [highlightFirstSelectedValue]="true" [autoFocus]="false" [hasCustomListTemplate]="true"
              [isDropdownIconVisible]="false" [hasCustomEditableField]="false"
              [value]="_estimate.followUpCampaign?.title?.toUpperCase()" [fontSize]="12"
              [suggestions]="_campignSuggestions" [closeOnSelection]="true" (appCompletedMethod)="search($event)"
              (appClear)="onSearchClear()">
              <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                <li class="font-12 font-600 bg-gary-90 p-2 source-suggestions-label"
                  *ngIf="sourceCampaigns?.promotionalCampaigns?.length > 0">
                  <p class="mb-0 font-black">Promotional Campaign</p>
                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>
                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let promotional of sourceCampaigns?.promotionalCampaigns; let i = index" id="item-{{i}}"
                      (click)="onSearchSelect(promotional, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="promotional?.title">{{promotional?.title}}</span>
                          <span class="font-11 text-initial font-gray-55">{{promotional?.type}}</span>
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial">
                            Last message sent: {{promotional?.sendDate | date: 'MMM d, yyyy'}}
                          </span>
                          <span class="font-gray-55 font-11 text-initial">Promotion</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="font-12 font-600 bg-gary-90 p-2 bt-1 source-suggestions-label"
                  *ngIf="sourceCampaigns?.followUps?.length > 0">
                  <p class="mb-0 font-black">Follow-up Campaign</p>

                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>

                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let followup of sourceCampaigns?.followUps; let j = index" id="item-{{j}}"
                      (click)="onSearchSelect(followup, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="followup?.title">{{followup?.title}}</span>
                          <span class="font-11 text-initial font-gray-55">{{followup?.type}}</span>
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial">
                            Last message sent: {{followup?.sendDate | date: 'MMM d, yyyy'}}
                          </span>
                          <span class="font-gray-55 font-11 text-initial">Follow-up</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="font-12 font-600 bg-gary-90 p-2 bt-1 source-suggestions-label"
                  *ngIf="sourceCampaigns?.leadCampaigns?.length > 0">
                  <p class="mb-0 font-black">Lead Source</p>

                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>

                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let lead of sourceCampaigns?.leadCampaigns; let k = index" id="item-{{k}}"
                      (click)="onSearchSelect(lead, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="followup?.title">{{lead?.title}}</span>
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial">
                            {{lead?.category}}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ng-template>
            </app-auto-complete>
            <i class="fal fa-times clear-vehicle-filter-btn p-2 pointer hover"
              [ngClass]="{'disabled-estimate-icon': isArchived}" *ngIf="_estimate.followUpCampaign?.title"
              (click)="clearSourceCampaign($event,_estimate.followUpCampaign)">
            </i>
          </div>
        </div>
      </div>

      <!-- Order Status -->
      <div class="ui-g-12 p-1 order mt-2">
        <p>ORDER STATUS</p>

        <div class="mt-1">
          <div [ngClass]="{'disabled-estimate-field': isArchived}">
            <app-switch-button id="estimate-order-status-switch" valueField="value" [showselectedCircle]="false"
              [value]="{ value: _estimate.orderStatus }" [options]="orderStatus"
              (appChange)="onStatusSelect('orderStatus', $event)"></app-switch-button>
          </div>
        </div>

        <div *ngIf="_estimate.orderStatus === 'invoice' && _estimate.invoiceDate" class="ui-g-12 p-0 pt-1"
          [ngClass]="{'disabled-estimate-field': _estimate?.isFinalized || (isArchived && !_estimate?.isInvoiceLock)}">
          <div class="status-change-by ui-g-11 p-0">
            <span>Invoice date: {{ invoiceBy.date }}, {{ invoiceBy.time }}</span>
            <span class="capitalize"> ({{ invoiceBy.name }})</span>
          </div>
          <i class="ui-g-1 p-0 text-right pointer far fa-edit" (click)="openUpdateInvoiceDateDialog()"></i>
        </div>
      </div>
    </ng-container>

    <!-- Workflow Status -->
    <div class="ui-g-12 workflow p-1 pb-3 mt-2 bb-light">
      <p>Workflow Status</p>

      <div class="mt-1">
        <div [ngClass]="{'disabled-estimate-field': isArchived && !_estimate?.isInvoiceLock || _estimate?.adjustmentsForInvoice?.code}">
          <app-dropdown id="est-workflow-status" listId="est-workflow-status-list" placeholder="Select workflow"
            theme="border" styleClassSelectedView="p-6p text-transform-uppercase" inactiveItemsKey="disabled"
            [selectInactiveItems]="false" styleClassDropdownListItem="text-transform-uppercase" scrollHeight="198px"
            [options]="workFlowStatuses" [isDropdownIconVisible]="true" [fullyControlled]="true"
            [value]="workFlowStatus" [disabled]="isArchived && !_estimate?.isInvoiceLock || _estimate?.adjustmentsForInvoice?.code"
            (appSelect)="onStatusSelect('workFlowStatus', $event)">
          </app-dropdown>
        </div>
      </div>
    </div>

    <ng-template #adjumentsInvoiceDetails>
      <div id="ro-workflow-list" class="ui-g-12 p-0 mt-2 communication-details">
        <div class="ui-g-12 p-1">
          <div class="ui-g-6 p-0 heading">Order Status</div>

          <div class="ui-g-6 p-0 value text-right font-primary">
            Invoice
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Carfax Reporting -->
    <div class="ui-g-12 p-1 order mt-2" *ngIf="isCarfaxEnabled">
      <p>CARFAX REPORTING</p>

      <div class="flex-start-center mt-1">
        <!-- Carfax urgent posting section -->
        <span *ngIf="carfaxReportSent" class="flex-row font-gray font-14 font-400">
          <span class="flex-around-center carfax-checked mr-1">
            <i class="fa fa-check"></i>
          </span>
          This RO has been reported to Carfax.
        </span>

        <ng-container *ngIf="!carfaxReportSent">
          <app-switch-pill *ngIf="!isCarfaxUrgentPostingEnabled" position="end" [fontSize]="12"
            [disabled]="_estimate?.orderStatus === 'invoice' || isArchived"
            [label]="carfaxReportingEnabled? 'This RO will be reported to Carfax' : 'This RO will not be reported to Carfax'"
            [isActive]="carfaxReportingEnabled" (appChange)="handleCarfaxReportingUpdate($event)">
          </app-switch-pill>

          <!-- Carfax urgent posting section -->
          <ng-container *ngIf="isCarfaxUrgentPostingEnabled">
            <span *ngIf="!carfaxReportSent" class="flex-row">
              <app-switch-pill position="end" [ngClass]="{'mr-3': carfaxReportingEnabled}" [fontSize]="12"
                [disabled]="_estimate?.orderStatus === 'invoice' || isArchived"
                [label]="carfaxReportingEnabled? 'Report to Carfax' : 'This RO will not be reported to Carfax'"
                [isActive]="carfaxReportingEnabled" (appChange)="handleCarfaxReportingUpdate($event)">
              </app-switch-pill>

              <app-switch-pill *ngIf="carfaxReportingEnabled" position="end" [fontSize]="12"
                [disabled]="_estimate?.orderStatus === 'invoice' || isArchived" label="Urgent"
                [isActive]="carfaxUrgentReportingEnabled" (appChange)="handleCarfaxUrgentReporting($event)">
              </app-switch-pill>
            </span>
          </ng-container>
        </ng-container>

      </div>
    </div>

    <!-- Service Advisor -->
    <div class="ui-g-12 p-1 order mt-2" *ngIf="serviceWriterEnabled">
      <p>SERVICE ADVISOR</p>

      <div class="flex-start-center mt-1">
        <app-dropdown id="est-workflow-status" listId="est-workflow-status-list" placeholder="Service advisor"
          theme="border" class="width-100p" field="name" styleClassSelectedView="p-6p" scrollHeight="198px"
          [disabled]="isServiceWriterUpdating || isArchived" [options]="technicians" [isDropdownIconVisible]="true"
          [fullyControlled]="true" [value]="_estimate?.serviceWriter"
          (appSelect)="onSelectServiceWriter('serviceWriter', $event)">
        </app-dropdown>
      </div>
    </div>

    <div class="ui-g-12 p-1 order mt-2">
      <p>Payment Status</p>

      <div class="flex-start-center mt-1">
        <app-dropdown id="est-payment-status" listId="est-payment-status-list" placeholder="Payment Status"
          theme="border" class="width-100p" field="name" styleClassSelectedView="p-6p" scrollHeight="198px"
          [options]="paymentStatusOptions" [isDropdownIconVisible]="true" [fullyControlled]="true"
          [value]="_estimate.paymentStatus" [disabled]="isArchived" (appSelect)="onSelectPayment($event)">
        </app-dropdown>
      </div>
      <span class="font-gray-55 font-10 text-initial" *ngIf="_estimate.paymentStatusUpdateDate">
        Last updated: {{_estimate.paymentStatusUpdateDate}}&nbsp;<span
          *ngIf="_estimate.paymentStatusUpdatedBy">({{_estimate.paymentStatusUpdatedBy}})</span>
      </span>
    </div>
  </div>
  <!-- End Estimate Status Details -->

  <!-- Start Estimate Communication Details -->
  <div id="ro-workflow-list" class="ui-g-12 padding-lrb-12 pt-0 communication-details">
    <div class="ui-g-12 p-1">
      <div class="ui-g-6 p-0 heading">Order No.</div>

      <div *ngIf="_estimate.code" class="ui-g-6 p-0 value text-right">
        #{{ _estimate.code || '-' }}
      </div>
    </div>

    <!-- Start invoice no. -->
    <div class="ui-g-12 p-1" *ngIf=" _estimate.orderStatus === 'invoice'">
      <div
        *ngIf="!_estimate?.invoiceType && !isInvCodEqToEstCode && isManualInvCodeEnabled && canUpdateInvoiceNumber else readOnlyInvoice"
        class="ui-g-7 p-0 heading ro-invoice-manual">
        <app-content-overlay right="auto" arrowTop="-6px" arrowRight="4%" [showArrow]="true"
          [ngClass]="{ 'disabled-estimate-field': isArchived && !_estimate?.isInvoiceLock }">
          <ng-template appTemplate="item">
            <div class="width-100p flex-between-center">
              <div>
                <span>Invoice No.</span>
                <i class="ml-1 far fa-edit"></i>
              </div>
            </div>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close">
            <div class="invoice-code-overlay p-2 pt-4">
              <div class="invoice-code-current mb-4">
                <app-input id="invoice-code-current" placeholder="Current invoice no." styleClassLabel="font-100"
                  [fontSize]="12" [allowDecimal]="true" [floatingLabel]="true" [disabled]="true"
                  [value]="_estimate?.invCode">
                </app-input>
              </div>

              <div class="invoice-code-new mb-4">
                <app-input id="invoice-code-new" placeholder="New invoice no." styleClassLabel="font-100"
                  [allowDecimal]="true" [fontSize]="12" [floatingLabel]="true" [value]="newInvCode"
                  [isInvalid]="errors?.newInvCode" [errorMessage]="errors?.newInvCode"
                  (appChange)="handleInvCodeChange($event)" (appFocus)="errors.newInvCode = ''"
                  (appBlur)="_handleCheckForUniqueInvCode()">
                </app-input>
              </div>

              <div class="invoice-code-info">
                <span class="font-12">
                  Invoice # will not be updated on past data such as old PDFs, notifications, and activity logs
                </span>

                <i class="fal fa-info-circle text-dark pl-1"
                  pTooltip="Invoice # will be updated on RO, Workboard, Lists, Reports and Customer screens"></i>
              </div>

              <div class="invoice-code-footer flex-end-center pt-2 mt-1">
                <button class="btn btn-border p-1 pr-3 pl-3 mr-2" (click)="close()">Cancel</button>
                <button class="btn btn-primary p-1 pr-3 pl-3" [disabled]="errors?.newInvCode || !newInvCode"
                  (click)="updateInvCode()">
                  <span [ngClass]="{'pr-2': isInvoiceCodeUpdating}">Confirm</span>
                  <i class="fal fa-spinner rotate" *ngIf="isInvoiceCodeUpdating"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </app-content-overlay>
      </div>

      <ng-template #readOnlyInvoice>
        <div class="ui-g-7 p-0 heading ro-invoice-manual">
          <div class="width-100p flex-between-center">
            <span>Invoice No.</span>
          </div>
        </div>
      </ng-template>
      <!-- End invoice no. -->

      <div *ngIf="_estimate.code" class="ui-g-5 p-0 value text-right">
        #{{ (_estimate.orderStatus === 'invoice' && _estimate.invCode) ? _estimate.invCode : _estimate.code || '-' }}
      </div>
    </div>

    <div *ngIf="
        pdfs?.invoice?.url ||
        pdfs?.estimate?.url ||
        pdfs?.inspection?.url ||
        pdfs?.approved?.url
      " class="ui-g-12 p-0 bb-light">
      <!-- Invoice PDF -->
      <div *ngIf="pdfs?.invoice?.url && invoiceBy?.date" class="ui-g-12 p-1">
        <div class="ui-g-6 p-0 heading">
          Invoice -
          <span class="font-primary pointer" (click)="handleDownloadPdf('invoice')">
            PDF
          </span>
        </div>
        <div class="ui-g-6 p-0 text-right value">
          {{ invoiceBy?.date | date: 'MMM d, yy' }}
        </div>
      </div>

      <!-- Estimate PDF -->
      <div *ngIf="pdfs?.estimate?.url" class="ui-g-12 p-1">
        <div class="ui-g-7 p-0 heading">
          Estimate -
          <span class="font-primary pointer" (click)="handleDownloadPdf('estimate')">
            PDF
          </span>
        </div>
        <div class="ui-g-5 p-0 text-right value">
          {{ pdfs?.estimate?.date | date: 'MMM d, yy' }}
        </div>
      </div>

      <!-- Invoice PDF -->
      <div *ngIf="pdfs?.inspection?.url" class="ui-g-12 p-1">
        <div class="ui-g-7 p-0 heading">
          Inspection -
          <span class="font-primary pointer" (click)="handleDownloadPdf('inspection')">
            PDF
          </span>
        </div>
        <div class="ui-g-5 p-0 text-right value">
          {{ pdfs?.inspection?.date | date: 'MMM d, yy' }}
        </div>
      </div>

      <!-- Approved pdf -->
      <div *ngIf="pdfs?.approved?.url && authorizedByCustomer" class="ui-g-12 p-1">
        <div class="ui-g-8 p-0 heading">
          Approved Estimate -
          <span class="font-primary pointer" (click)="handleDownloadPdf('approved')">
            PDF
          </span>
        </div>
        <div class="ui-g-4 p-0 text-right value">
          {{ pdfs?.approved?.date | date: 'MMM d, yy' }}
        </div>
      </div>

      <!-- Approved invoice pdf -->
      <div *ngIf="pdfs?.approvedInvoice?.url" class="ui-g-12 p-1">
        <div class="ui-g-8 p-0 heading">
          Approved Invoice -
          <span class="font-primary pointer" (click)="handleDownloadPdf('approvedInvoice')">
            PDF
          </span>
        </div>
        <div class="ui-g-4 p-0 text-right value">
          {{ pdfs?.approvedInvoice?.date | date: 'MMM d, yy' }}
        </div>
      </div>
    </div>
  </div>
</div>

<app-custom-toaster [isShowToaster]="showToaster" [toasterOpts]="toaster" (actionClicked)="onToasterAction($event)">
</app-custom-toaster>

